import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-sa': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM137.7 221C150.7 137.1 218.2 125.3 246.6 125.3 346.4 125.3 374.1 207.8 374.1 259.5 374.1 323.1 333.1 392.4 245.2 392.4 206.3 392.4 146.1 372.4 135.8 295.4H198.3C199.8 325.5 217.9 340.6 252.8 340.6 276.1 340.6 310.8 322.4 310.8 257.8 310.8 175.3 261.7 177.2 254.1 177.2 221 177.2 202.4 191.8 198.3 221H216.5L167.3 270.2 118.3 221H137.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-sa.js
// module id = dS/n
// module chunks = 144